import { render, staticRenderFns } from "./PanelGate.vue?vue&type=template&id=1e7fe0a5&"
import script from "./PanelGate.vue?vue&type=script&lang=js&"
export * from "./PanelGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e7fe0a5')) {
      api.createRecord('1e7fe0a5', component.options)
    } else {
      api.reload('1e7fe0a5', component.options)
    }
    module.hot.accept("./PanelGate.vue?vue&type=template&id=1e7fe0a5&", function () {
      api.rerender('1e7fe0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelGate.vue"
export default component.exports